import {
  ADD_IMAGES_TO_VENUE,
  ADD_IMAGE_TO_EVENT,
  CREATE_VENUE,
  CREATE_VENUE_FAILED,
  CREATE_VENUE_SUCCESS,
  DELETE_VENUE_PICTURE_SUCCESS,
  DELETE_VENUE_PICTURE_FAILURE,
  GET_FEATURES_BY_VENUE_ID,
  GET_FEATURES_BY_VENUE_ID_FAILED,
  GET_FEATURES_BY_VENUE_ID_SUCCESS,
  GET_PICTURES_BY_VENUE,
  GET_PICTURES_BY_VENUE_FAILED,
  GET_PICTURES_BY_VENUE_SUCCESS,
  GET_VENUES,
  GET_VENUES_FAILED,
  GET_VENUES_SUCCESS,
  GET_VENUE_BY_ID,
  GET_VENUE_BY_ID_FAILED,
  GET_VENUE_BY_ID_SUCCESS,
  GET_VENUE_FEATURES,
  GET_VENUE_FEATURES_FAILED,
  GET_VENUE_FEATURES_SUCCESS,
  SET_BANNER_VENUE,
  SET_CURRENT_VENUE_USER,
  SET_PRINCIPAL_BANNER_VENUE,
  UPDATE_VENUE,
  UPDATE_VENUE_FAILED,
  UPDATE_VENUE_SUCCESS,
} from './constants';

const getVenuePictures = () => {
  const key = 'VENUE_PICTURES';
  if (key in localStorage) return JSON.parse(localStorage.getItem(key));
  return [];
};

const initialState = {
  currentVenue: JSON.parse(localStorage.getItem('currentVenue')) || null,
  venuePictures: [],
  currentVenuePictures: getVenuePictures(),
  eventPicture: [],
  banner: undefined,
  principalBanner: undefined,
  features: [],
  venueFeatures: {},
  error: null,
  loading: false,
  success: undefined,
  venueUpdated: undefined,
  venueDetails: undefined,
};

const venueReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case CREATE_VENUE:
      return { ...state, loading: true };
    case CREATE_VENUE_SUCCESS:
      return {
        ...state,
        currentVenue: action.payload.venue,
        success: action.payload.success,
        venuePictures: [],
        failedMessage: undefined,
        loading: false,
        error: undefined,
      };
    case CREATE_VENUE_FAILED:
      return {
        ...state,
        error: action.payload.error,
        successMessage: undefined,
        loading: false,
      };
    case ADD_IMAGES_TO_VENUE: {
      const [onePicture] = action.payload.pictures;
      let banner;
      if (onePicture) {
        const { file } = onePicture;
        const src = URL.createObjectURL(onePicture.file);
        banner = { src, file };
      }
      return { ...state, venuePictures: action.payload.pictures, banner };
    }
    case ADD_IMAGE_TO_EVENT: {
      const [onePicture] = action.payload.pictures;
      let banner;
      if (onePicture) {
        const { file } = onePicture;
        const src = URL.createObjectURL(onePicture.file);
        banner = { src, file };
      }
      return { ...state, eventPicture: action.payload.pictures, banner };
    }
    case SET_CURRENT_VENUE_USER:
      localStorage.setItem('currentVenue', JSON.stringify(action.payload.venue));
      return { ...state, currentVenue: action.payload.venue };
    case GET_VENUE_BY_ID:
      return { ...state, loading: true };
    case GET_VENUE_BY_ID_SUCCESS:
      return { ...state, venueDetails: action.payload.venue, loading: false };
    case GET_VENUE_BY_ID_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    case GET_VENUES:
      return { ...state, loading: true };
    case GET_VENUES_SUCCESS:
      return { ...state, venueList: action.payload.venueList, loading: false };
    case GET_VENUES_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    case GET_VENUE_FEATURES:
    case GET_FEATURES_BY_VENUE_ID:
      return { ...state, loading: true };
    case GET_VENUE_FEATURES_SUCCESS:
      return { ...state, features: action.payload.features, loading: false };
    case GET_FEATURES_BY_VENUE_ID_SUCCESS:
      return { ...state, venueFeatures: action.payload.data, loading: false };
    case GET_VENUE_FEATURES_FAILED:
    case GET_FEATURES_BY_VENUE_ID_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    case SET_BANNER_VENUE: {
      return { ...state, banner: action.payload.picture };
    }
    case SET_PRINCIPAL_BANNER_VENUE: {
      return { ...state, principalBanner: action.payload.picture };
    }
    case UPDATE_VENUE: {
      localStorage.setItem('currentVenue', JSON.stringify(action.payload.venue));
      return { ...state, loading: true, currentVenue: action.payload.venue };
    }
    case UPDATE_VENUE_SUCCESS:
      return { ...state, venueUpdated: action.payload.venue, loading: false };
    case UPDATE_VENUE_FAILED:
      return { ...state, venueUpdated: undefined, error: action.payload.error, loading: false };
    case GET_PICTURES_BY_VENUE:
      return { ...state, loading: true };
    case GET_PICTURES_BY_VENUE_SUCCESS: {
      localStorage.setItem('VENUE_PICTURES', JSON.stringify(action.payload.pictures));
      return { ...state, currentVenuePictures: action.payload.pictures, loading: false };
    }
    case DELETE_VENUE_PICTURE_SUCCESS: {
      const updatedPictures = state.currentVenuePictures.filter(
        (picture) => picture.key !== action.payload,
      );
      localStorage.setItem('VENUE_PICTURES', JSON.stringify(updatedPictures));
      return {
        ...state,
        currentVenuePictures: updatedPictures,
        error: null,
      };
    }
    case DELETE_VENUE_PICTURE_FAILURE:
      return { ...state, error: action.payload };

    case GET_PICTURES_BY_VENUE_FAILED:
      return { ...state, error: action.payload.error, loading: false };
    default:
      return state;
  }
};

export default venueReducer;
